/** Show Me opens for these accounts. Bryan is Brian King. */
const PORTAL_ASSISTANT_DEMO_EMAILS = [
  'adam@freetech.co',
  'brian@optictruckworks.com',
  'colton@optictruckworks.com',
] as const

export function isPortalAssistantDemoAudience(email: string | null | undefined): boolean {
  const normalized = (email || '').trim().toLowerCase()
  return (PORTAL_ASSISTANT_DEMO_EMAILS as readonly string[]).includes(normalized)
}
